"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _buildUrl = _interopRequireDefault(require("./buildUrl")),
    _getData = _interopRequireDefault(require("./getData")),
    _default = function _default(a) {
  var b = null,
      c = {};
  if ("string" != typeof a.accessToken && !a.url) throw new Error("Missing accessToken.");
  return "undefined" != typeof document && null !== document && (b = a.url || (0, _buildUrl.default)(a), c = (0, _getData.default)(b)), c;
};

exports.default = _default;